<div class="container appSeoTextsWrapper" [innerHTML]="currentItem" *ngIf="currentItem">
</div>